import React, { useState, useEffect, useCallback } from 'react';
import PageTitle from '../../../Utils/PageTitle';
import Spinner from '../../CustomComponents/Spinner';
import CustomTypography from '../../CustomComponents/CustomTypography';
import FloatLabel from '../../CustomComponents/FloatingLabel';
import { notification, Tabs } from 'antd';
import {
  getFacilityDetails,
  getEhrFields,
  getEhrList,
  updateFacilityConfig,
  addFacilityConfig,
  addFacilityTemplateByGod,
  updateFacilityTemplateByGod,
  disableFacilityTemplateByGod,
  getFacilityTemplateByIdGod
} from '../../../Apis/Facility';
import {
  ContainerRow,
  TitleRow,
  ProfileComponent
} from '../styledComponents';
import {
  CustomRow,
  StyledCol,
  StyledDisableButton
} from '../Settings/EhrConfiguration/styledComponents';
import { useSelector, useDispatch } from 'react-redux';
import { AddUser } from '../../../Redux/Actions/User';
import { useHistory, useParams, Link } from 'react-router-dom';
import EHRDetails from '../Settings/EhrConfiguration/EHRDetails';
import BreadCrumbComponent from '../../CustomComponents/BreadCrumbComponent';
import LinkoffIcon from '../../../Assets/Icons/LinkoffIcon';
import ConfirmationModal from '../../CustomComponents/ConfirmationModal';
import { StyledDisableFacilityModalDiv } from '../Settings/EhrConfiguration/styledComponents';
import FacilityUsers from './FacilityUsers';

const { TabPane } = Tabs;

const DictionaryFacilityConfiguration = () => {
  const [loading, setLoading] = useState(false);
  const [ehrDataLoading, setEhrDataLoading] = useState(false);
  const [updateLoading, setUpdateLoading] = useState(false);
  const [ehrList, setEhrList] = useState([]);
  const [selectedEhr, setSelectedEhr] = useState('');
  const [theme] = useSelector(state => [state.themeReducer]);
  const [ehrFieldData, setEhrFieldData] = useState(null);
  const [ehrFields, setEhrFields] = useState(null);
  const [edit, setEdit] = useState(false);
  const [clinicConfigured, setClinicConfigured] = useState(false);
  const [transcriptionFlow, setTranscriptionFlow] = useState(null);
  const [facilityName, setFacilityName] = useState('');
  const [
    rangeForDischargedPatientsDetails,
    setRangeForDischargedPatientsDetails
  ] = useState('30');
  const [saveDisabled, setSaveDisabled] = useState(null);
  const [
    showRangeForDischargedPatientsEhrType,
    setShowRangeForDischargedPatientsEhrType
  ] = useState(false);
  const [showRangeForDischargedPatients, setShowRangeForDischargedPatients] =
    useState(false);
  const [disableModalVisible, setDisableModalVisible] = useState(false);
  const [disableLoading, setDisableLoading] = useState(false);
  const user = JSON.parse(localStorage.getItem('user'));
  const { facilityId, tab } = useParams();
  const activeTab = tab === 'users' ? 'users' : 'details';

  const history = useHistory();
  const location = history.location;
  const facilityDataFromLocation = location?.state?.facilityData;
  const dispatch = useDispatch();


  let BreadCrubItems = [
    {
      name: 'Facility',
      path: '/dashboard/facility-management'
    },
    {
      name: facilityId === 'new' ? 'New Facility' : 'Facility Configuration',
      path:
        facilityId === 'new'
          ? undefined
          : `/dashboard/facility-management/${facilityId}/details`
    }
  ];

  if (facilityId !== 'new' && facilityName) {
    BreadCrubItems.push({ name: facilityName });
  }

  useEffect(() => {
    getEhrAndClinicList();
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    if (ehrFieldData) {
      setShowRangeForDischargedPatients(ehrFieldData.allPatientsRequired);

      if (ehrFieldData.ehrType) {
        setShowRangeForDischargedPatientsEhrType(
          ehrFieldData.ehrType === 'pointHealth-emr'
        );
      }

      if (ehrFieldData.rangeForDischargedPatients) {
        setRangeForDischargedPatientsDetails(
          ehrFieldData.rangeForDischargedPatients.toString()
        );
      }
    }
  }, [ehrFieldData]);

  useEffect(() => {
    if (facilityId === 'new') {
      setClinicConfigured(false);
      setEdit(true);
    } else {
      setClinicConfigured(true);
      // For God user editing facility template, enable edit mode initially
      if (user?.userType === 'cascadeGod') {
        setEdit(false);
      }
    }
    // eslint-disable-next-line
  }, []);

  const getEhrAndClinicList = () => {
    setLoading(true);
    getEhrList()
      .then(response => {
        if (response.data.success) {
          let data = response.data.result
            .filter(field => field.isActive)
            .map(field => {
              return {
                name: field.ehrName,
                value: field.ehrType
              };
            });
          setEhrList(data);
          if (data.length === 1) {
            setSelectedEhr(data[0].value);
            setShowRangeForDischargedPatientsEhrType(
              data[0].value === 'pointHealth-emr'
            );
            getEhrFieldDetails(data[0].value);
          }
        } else {
          notification['error']({
            message: 'Failed',
            description: response.data.message
          });
          setLoading(false);
        }
      })
      .catch(err => {
        console.log(err);
        setLoading(false);
      });

    if (facilityId === 'new') {
      setLoading(false);
    } else if (user?.userType === 'cascadeGod' && facilityDataFromLocation) {
      // Use facility template data from location state (no API call needed)
      setFacilityName(facilityDataFromLocation.facilityName);
      const data = facilityDataFromLocation.ehrConfigForFacilityTemplate;
      setSelectedEhr(data.ehrType);
      if (data.ehrType.length > 0)
        getEhrFieldDetails(data.ehrType, data);
      setEhrFieldData(data);
      setLoading(false);
    } else if (user?.userType === 'cascadeGod') {
      // No location state (e.g. deep-link / page refresh on a sub-tab) -
      // fetch the facility template by id so the page is refresh-safe.
      getFacilityTemplateByIdGod(facilityId)
        .then(response => {
          if (response.data.success && response.data.result[0]) {
            const template = response.data.result[0];
            setFacilityName(template.facilityName);
            const data = template.ehrConfigForFacilityTemplate;
            setSelectedEhr(data.ehrType);
            if (data.ehrType.length > 0) getEhrFieldDetails(data.ehrType, data);
            setEhrFieldData(data);
            setLoading(false);
          } else {
            notification['error']({
              message: 'Failed',
              description: response.data.message
            });
            setLoading(false);
            history.push('/dashboard/facility-management');
          }
        })
        .catch(err => {
          console.log(err);
          setLoading(false);
          history.push('/dashboard/facility-management');
        });
    } else {
      getFacilityDetails(facilityId)
        .then(response => {
          if (response.data.success) {
            setFacilityName(response.data.result[0].facilityName);
            const data = response.data.result[0].ehrConfiguration;
            setSelectedEhr(data.ehrType);
            setTranscriptionFlow(data.transcriptionFlow);
            if (data.ehrType.length > 0)
              getEhrFieldDetails(data.ehrType, data);
            setEhrFieldData(data);
            setLoading(false);
          } else {
            notification['error']({
              message: 'Failed',
              description: response.data.message
            });
            setLoading(false);
          }
        })
        .catch(err => {
          console.log(err);
          setLoading(false);
        });
    }
  };

  const getEhrFieldDetails = (type, clinicInfo) => {
    setEhrDataLoading(true);
    getEhrFields(facilityId, type)
      .then(response => {
        if (response.data.success) {
          const data = response.data.result;
          if (type === 'pointHealth-emr') {
            let maskedData = {};

            // If clinicInfo has maskedText fields (from facility template), decode them
            if (clinicInfo) {
              data.forEach(item => {
                if (item.fieldType === 'maskedText' && clinicInfo[item.field]) {
                  maskedData[item.field] = window.atob(clinicInfo[item.field]);
                } else if (item.fieldType === 'maskedText') {
                  maskedData[item.field] = window.atob(item.value);
                }
              });
            } else {
              // No clinicInfo, use default values from API
              data.forEach(item => {
                if (item.fieldType === 'maskedText') {
                  maskedData[item.field] = window.atob(item.value);
                } else if (item.fieldType === 'text' && item.value) {
                  maskedData[item.field] = item.value;
                }
              });
            }

            setEhrFieldData({
              ...clinicInfo,
              ...maskedData,
              transcriptionFlow: transcriptionFlow
                ? transcriptionFlow
                : user.transcriptionFlow
            });
          } else if (type === 'open-emr') {
            let ehrBaseUrl = null;
            let ehrUserName = null;
            let ehrPassword = null;
            if (clinicInfo?.ehrBaseUrl) {
              ehrBaseUrl = clinicInfo.ehrBaseUrl;
              ehrUserName = window.atob(clinicInfo.ehrUserName);
              ehrPassword = window.atob(clinicInfo.ehrPassword);
              delete clinicInfo.ehrBaseUrl;
              delete clinicInfo.ehrUserName;
              delete clinicInfo.ehrPassword;
            }
            setEhrFieldData({
              ...clinicInfo,
              ehrBaseUrl: ehrBaseUrl,
              ehrUserName: ehrUserName,
              ehrPassword: ehrPassword,
              transcriptionFlow: transcriptionFlow
                ? transcriptionFlow
                : user.transcriptionFlow
            });
          } else {
            let ehrBaseUrl = null;
            let ehrUserName = null;
            let ehrPassword = null;
            data.forEach(item => {
              if (item.field === 'ehrBaseUrl') {
                ehrBaseUrl = item.value;
              } else if (
                item.field === 'ehrUserName' &&
                item.value.length > 0
              ) {
                ehrUserName = window.atob(item.value);
              } else if (
                item.field === 'ehrPassword' &&
                item.value.length > 0
              ) {
                ehrPassword = window.atob(item.value);
              } else {
                return;
              }
            });
            setEhrFieldData({
              ...clinicInfo,
              ehrBaseUrl: ehrBaseUrl,
              ehrUserName: ehrUserName,
              ehrPassword: ehrPassword,
              transcriptionFlow: transcriptionFlow
                ? transcriptionFlow
                : user.transcriptionFlow
            });
          }

          setEhrFields(data);
          setEhrDataLoading(false);
        } else {
          notification['error']({
            message: 'Failed',
            description: response.data.message
          });
          setEhrDataLoading(false);
        }
      })
      .catch(err => {
        console.log(err);
        setEhrDataLoading(false);
      });
  };

  const ehrSelectHanlder = ({ changedValue }) => {
    setShowRangeForDischargedPatientsEhrType(
      changedValue === 'pointHealth-emr'
    );
    setSaveDisabled(false);
    const ehr = ehrList.find(item => item.value === changedValue);
    setSelectedEhr(ehr.value);
    getEhrFieldDetails(ehr.value);
  };

  const facilityNameChangeHandler = e => {
    setFacilityName(e.target.value);
    setSaveDisabled(selectedEhr !== '' && edit ? false : saveDisabled);
  };

  const onFormSubmit = values => {
    values.rangeForDischargedPatients = parseInt(
      rangeForDischargedPatientsDetails
    );

    // Check if fields should be hidden for cascadeGod users (creating or editing)
    const shouldHideFields = user?.userType === 'cascadeGod';

    if (!shouldHideFields && values.transcriptionFlow.changedValue == null) {
      notification['error']({
        message: 'Please select Transcription Flow'
      });
      return;
    }
    setSaveDisabled(true);
    if (facilityName.length > 0) {
      setUpdateLoading(true);

      ehrFields.forEach(item => {
        if (item.fieldType === 'maskedText') {
          values[item.field] = window.btoa(values[item.field]);
        }
      });

      if (values.noteType) {
        let noteTypes =
          ehrFields &&
          ehrFields.find(field => field.field === 'noteType').value;
        let selectedNoteType = noteTypes.find(
          item =>
            item.value === values.noteType.changedValue ||
            item.name === values.noteType.changedValue
        );
        values.noteType = selectedNoteType.value;
      }

      let payload;
      let apiCall;

      // Build payload based on user type
      if (shouldHideFields && facilityId === 'new') {
        // CascadeGod creating new facility - use facility template API
        payload = {
          ehrConfigForFacilityTemplate: {
            ehrType: selectedEhr,
            appName: values.appName || '',
            clientId: values.clientId || '',
            clientSecret: values.clientSecret || '',
            ehrBaseUrl: values.ehrBaseUrl || '',
            facilityId: values.facilityId || '',
            organisationId: values.organisationId || ''
          },
          facilityName: facilityName
        };
        apiCall = addFacilityTemplateByGod(payload);
      } else if (shouldHideFields && facilityId !== 'new') {
        // CascadeGod editing existing facility template
        payload = {
          ehrConfigForFacilityTemplate: {
            ehrType: selectedEhr,
            appName: values.appName || '',
            clientId: values.clientId || '',
            clientSecret: values.clientSecret || '',
            ehrBaseUrl: values.ehrBaseUrl || '',
            facilityId: values.facilityId || '',
            organisationId: values.organisationId || ''
          },
          facilityName: facilityName
        };
        apiCall = updateFacilityTemplateByGod(facilityId, payload);
      } else {
        // Regular facility creation/update
        payload = {
          ehrConfiguration: {
            ehrType: selectedEhr,
            ...values,
            transcriptionFlow: values.transcriptionFlow.changedValue,
            reviewerCount: parseInt(values.reviewerCount.changedValue),
            allPatientsRequired:
              values.allPatientsRequired.changedValue === 'Yes' ? true : false,
            hl7Integration: selectedEhr === 'hl7-integration'
          },
          facilityName: facilityName
        };

        if (facilityId !== 'new') {
          payload.ehrConfigured = true;
          payload.id = facilityId;
        }

        const updatePayload = {
          allPatientsRequired:
            values.allPatientsRequired.changedValue === 'Yes' ? true : false,
          facilityName: facilityName,
          noteType: values.noteType,
          rangeForDischargedPatients: parseInt(rangeForDischargedPatientsDetails)
        };

        apiCall =
          facilityId === 'new'
            ? addFacilityConfig(payload)
            : updateFacilityConfig(facilityId, updatePayload);
      }

      apiCall
        .then(response => {
          if (response.data.success) {
            if (facilityId === 'new') {
              notification['success']({
                message: 'Added',
                description: 'Facility added successfully'
              });
            } else if (user?.userType === 'cascadeGod') {
              notification['success']({
                message: 'Updated',
                description: 'Facility template updated successfully'
              });
            }

            setUpdateLoading(false);
            setClinicConfigured(true);
            setEdit(false);

            // Update user data based on response
            if (shouldHideFields) {
              // CascadeGod user - default values
              user.transcriptionFlow = 'TRANSCRIPTION_ONLY';
              user.clinicConfigured = true;
              user.hl7Integration = selectedEhr === 'hl7-integration';
            } else {
              // Regular user - use response data
              if (
                response.data.result[0].ehrConfiguration.transcriptionFlow ===
                'TRANSCRIPTION_REVIEWER'
              ) {
                user.transcriptionFlow = 'TRANSCRIPTION_REVIEWER';
              } else {
                user.transcriptionFlow = 'TRANSCRIPTION_ONLY';
              }
              user.clinicConfigured = true;
              user.hl7Integration =
                response.data.result[0].ehrConfiguration.hl7Integration;
              user.emrHandlingData = response.data.emrHandlingData;
            }

            dispatch(AddUser(user));
            localStorage.setItem('user', JSON.stringify(user));
            history.push('/dashboard/facility-management');
          } else {
            setSaveDisabled(false);
            notification['error']({
              message: 'Failed',
              description: response.data.message
            });
            setUpdateLoading(false);
          }
        })
        .catch(err => {
          console.log(err);
          setUpdateLoading(false);
        });
    } else {
      notification['error']({
        message: 'Facility Name required'
      });
      setUpdateLoading(false);
    }
  };

  const showDisableModal = () => {
    setDisableModalVisible(true);
  };

  const handleDisableCancel = () => {
    setDisableModalVisible(false);
  };

  const handleDisableConfirm = async () => {
    setDisableLoading(true);
    try {
      const response = await disableFacilityTemplateByGod(facilityId);
      if (response.data.success) {
        notification['success']({
          message: 'Success',
          description: 'Facility template deleted successfully'
        });
        setDisableModalVisible(false);
        history.push('/dashboard/facility-management');
      } else {
        notification['error']({
          message: 'Failed',
          description: response.data.message
        });
      }
    } catch (err) {
      console.error('Error deleting facility template:', err);
      notification['error']({
        message: 'Error',
        description: 'Failed to delete facility template'
      });
    } finally {
      setDisableLoading(false);
    }
  };

  const showUsersTab = user?.userType === 'cascadeGod' && facilityId !== 'new';

  const facilityDetailsContent = (
    <ProfileComponent>
      <CustomRow gutter={[36, 36]}>
        <StyledCol span={12}>
          <FloatLabel
            label='EHR Type'
            primaryColor={theme['@text-color']}
            type='select'
            meta={ehrList}
            onChange={ehrSelectHanlder}
            value={{ changedValue: selectedEhr }}
            disabled={clinicConfigured ? true : edit ? false : true}
          />
        </StyledCol>
        <StyledCol span={12}>
          <FloatLabel
            label='Facility Name'
            primaryColor={theme['@text-color']}
            type='input'
            onChange={facilityNameChangeHandler}
            value={facilityName}
            disabled={edit ? false : true}
          />
        </StyledCol>
      </CustomRow>
      <EHRDetails
        theme={theme}
        ehrFields={ehrFields}
        onFormSubmit={onFormSubmit}
        buttonLoading={updateLoading}
        ehrFieldData={ehrFieldData}
        loading={ehrDataLoading}
        edit={edit}
        setEdit={setEdit}
        selectedEhr={selectedEhr}
        clinicConfigured={clinicConfigured}
        transcriptionFlow={transcriptionFlow}
        setTranscriptionFlow={setTranscriptionFlow}
        ehrSelectHanlder={ehrSelectHanlder}
        ehrList={ehrList}
        setFacilityName={setFacilityName}
        facilityName={facilityName}
        saveDisabled={saveDisabled}
        setSaveDisabled={setSaveDisabled}
        showRangeForDischargedPatientsEhrType={
          showRangeForDischargedPatientsEhrType
        }
        showRangeForDischargedPatients={showRangeForDischargedPatients}
        setShowRangeForDischargedPatients={setShowRangeForDischargedPatients}
        rangeForDischargedPatientsDetails={rangeForDischargedPatientsDetails}
        setRangeForDischargedPatientsDetails={
          setRangeForDischargedPatientsDetails
        }
        facilityId={facilityId}
        user={user}
      />
    </ProfileComponent>
  );

  return (
    <>
      <PageTitle title='Facility Configuration' />
      <ContainerRow>
        <TitleRow span={24} justify="space-between" align="middle">
          <CustomTypography color={theme['@text-color']}>
            Facility Configuration
          </CustomTypography>
          {user?.userType === 'cascadeGod' && facilityId !== 'new' && (
            <StyledDisableButton
              type='primary'
              danger
              icon={<LinkoffIcon />}
              onClick={showDisableModal}
            >
              Delete
            </StyledDisableButton>
          )}
        </TitleRow>
        <BreadCrumbComponent items={BreadCrubItems} />

        {showUsersTab && !loading && (
          <div style={{ display: 'flex', justifyContent: 'flex-end', width: '100%' }}>
            <Tabs activeKey={activeTab} type='card'>
              <TabPane
                key='details'
                tab={
                  <Link
                    to={`/dashboard/facility-management/${facilityId}/details`}
                    style={{
                      color:
                        activeTab === 'details'
                          ? theme['@primary-color']
                          : theme['@text-color']
                    }}
                  >
                    Facility Details
                  </Link>
                }
              />
              <TabPane
                key='users'
                tab={
                  <Link
                    to={`/dashboard/facility-management/${facilityId}/users`}
                    style={{
                      color:
                        activeTab === 'users'
                          ? theme['@primary-color']
                          : theme['@text-color']
                    }}
                  >
                    Users
                  </Link>
                }
              />
            </Tabs>
          </div>
        )}

        {loading ? (
          <Spinner />
        ) : showUsersTab && activeTab === 'users' ? (
          <FacilityUsers templateId={facilityId} />
        ) : (
          facilityDetailsContent
        )}
      </ContainerRow>

      <ConfirmationModal
        antdModalProps={{ centered: true, width: '500', closable: false }}
        visible={disableModalVisible}
        onCancel={handleDisableCancel}
        onOk={handleDisableConfirm}
        header={
          <CustomTypography color={theme['@text-color']}>
            Are you sure?
          </CustomTypography>
        }
        confirmation={true}
        buttonAlignCenter={true}
        buttonDisabled={disableLoading}
        loading={disableLoading}
      >
        <StyledDisableFacilityModalDiv>
          <h1>{`Do you really want to delete ${facilityName}?`}</h1>
          <p>This action will Delete the facility template and it cannot be imported by users.</p>
        </StyledDisableFacilityModalDiv>
      </ConfirmationModal>
    </>
  );
};

export default DictionaryFacilityConfiguration;
